export default {
  hub: "/admin",
  companies: {
    index: "/admin/companies",
    show: "/admin/companies/:id",
    create: "/admin/companies/new",
    emailConfiguration: {
      index: "/admin/companies/:companyId/email-configuration",
    },
  },
  users: {
    index: "/admin/users",
  },
  designSystem: "/admin/design-system",
  customInputs: "/admin/custom-inputs",
  examples: {
    floatingMd: "/admin/custom-inputs/md",
    floatingSm: "/admin/custom-inputs/sm",
  },
  calendarTest: "/admin/calendar-test",
  blazer: "/admin/blazer",
  flipper: "/admin/flipper",
  jobs: "/admin/jobs",
  pgHero: "/admin/pghero",
  litestream: "/admin/litestream",
  logs: "/admin/logs",
  errors: "/admin/errors",
};
